// removed by extract-text-webpack-plugin
module.exports = {"container":"container_122Jg","logo":"logo_1cNdV","action":"action_3zDRX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/index.scss
// module id = 141
// module chunks = 15